import React from "react";
import OrderHistoryAccordion from "@/features/my-order/features/order-history/components/OrderHistoryAccordion";
import {
  AccordionButton,
  AccordionItem,
  AccordionPanel,
} from "@chakra-ui/react";

interface Props {
  isOpen: boolean;
  btnComponent?: React.ReactNode;
  children?: React.ReactNode;
  hasData?: boolean;
}

function OrderHistoryInvoiceAccordion({
  isOpen,
  btnComponent,
  children,
  hasData = true,
}: Props) {
  return (
    <OrderHistoryAccordion index={isOpen ? [0] : []}>
      <AccordionItem>
        <AccordionButton
          justifyContent={"space-between"}
          alignItems={"center"}
          onClick={(event) => event.preventDefault()}
          cursor={"default"}
          _hover={{
            background: "none",
          }}
          padding={0}
          disabled={!hasData}
        >
          {btnComponent}
        </AccordionButton>
        <AccordionPanel padding={0} paddingRight={"1px"}>
          {children}
        </AccordionPanel>
      </AccordionItem>
    </OrderHistoryAccordion>
  );
}

export default OrderHistoryInvoiceAccordion;
